import { ComponentType } from 'react';

import Home from 'pages/Home';
import Notifications from 'pages/Notifications';

import InvoiceHome from 'pages/Invoice/Home';
import ProjectsByStatus from 'pages/Invoice/ProjectsByStatus';
import Invoices from 'pages/Invoice/Invoices';
import ClientBalances from 'pages/Invoice/ClientsBalance';

import Packages from 'pages/Invoice/Packages/List';
import PackageProfile from 'pages/Invoice/Packages/PackageProfile';
import CreatePackage from 'pages/Invoice/Packages/CreatePackage';

import SignIn from 'pages/SignIn';

import Teams from 'pages/Teams/TeamList';
import TeamsCreate from 'pages/Teams/CreateTeam';
import TeamProfile from 'pages/Teams/TeamProfile';

import PendingActions from 'pages/PendingActions';

import Offices from 'pages/Offices';
import Clients from 'pages/Clients';

import TasksOverview from 'pages/Projects/TasksOverview';
import ProjectCreate from 'pages/Projects/ProjectCreate';
import ProjectProfile from 'pages/Projects/ProjectProfile';

import UserProfile from 'pages/UserProfile';
import ValidateProjectPDF from 'pages/ValidateProjectPDF';

import OutsourceInvoices from 'pages/Invoice/OutsourceInvoices';
import RecruitmentHome from 'pages/Recruitment/Home';
import OutsourceProviders from 'pages/OutsourceProviders';

import IssueHome from 'pages/Issues/Home';

import MySuggestions from 'pages/Feedback/MySuggestions';
import UserSuggestions from 'pages/Feedback/AllSuggestions';
import BugReports from 'pages/Feedback/BugReports';

import { AppRoute } from '../config';

// This CANT live together inside the config/routes.ts config file
// as it would cause circular dependencies => vite HMR would not work at all
export const routeComponents: Record<AppRoute, ComponentType> = {
  clients: Clients,
  clientsBalance: ClientBalances,
  createPackage: CreatePackage,
  createProject: ProjectCreate,
  createTeam: TeamsCreate,
  home: Home,
  invoiceHome: InvoiceHome,
  invoiceProjectsByStatus: ProjectsByStatus,
  invoices: Invoices,
  issuesHome: IssueHome,
  login: SignIn,
  notifications: Notifications,
  offices: Offices,
  outsourceInvoices: OutsourceInvoices,
  outsourceProviders: OutsourceProviders,
  packageProfile: PackageProfile,
  packages: Packages,
  pendingActions: PendingActions,
  profile: UserProfile,
  projectProfile: ProjectProfile,
  recruitmentHome: RecruitmentHome,
  tasksOverview: TasksOverview,
  teamProfile: TeamProfile,
  teams: Teams,
  validatePDF: ValidateProjectPDF,

  mySuggestions: MySuggestions,
  userSuggestions: UserSuggestions,
  bugReports: BugReports,
};
